import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/Header";
import { ListeningResultList } from "../components/ListeningResultList";
import { getStudentLongSentenceListeningAchievements } from "../../../reducks/longSentence/operations";
import { RootEntity } from "../../../types";
import { PageTitle } from "../../../components/PageTitle";
import useLocationChange from "../../../utils/location";
import { clearLongSentenceAction } from "../../../reducks/longSentence/actions";
import Loading from "../../../components/Loading";

type State = {
  className: string;
};

export const LongSentenceDetails = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.class_id) {
      navigate("/404");
    } else {
      dispatch(getStudentLongSentenceListeningAchievements(params.class_id));
    }
  }, [dispatch]);

  const studentListeningAchievements = useSelector(
    (state: RootEntity) =>
      state.longSentence.studentLongSentenceListeningAchievements
  );

  const isLoading = useSelector((state: RootEntity) => state.isLoading);

  const location = useLocation();
  const state = location.state as State;

  // ページ遷移時にstoreから長文情報を削除する
  useLocationChange(() => {
    dispatch(clearLongSentenceAction());
  });

  return (
    <div>
      <Loading isLoading={isLoading} />
      <PageTitle title="長文詳細 - TiiFa LS" />
      <Header />
      <div className="teacher min-h-screen bg-e5 flex">
        <div className="w-full pc:ml-4 pc:border-l border-c pc:pl-10 pb-8">
          <div className="w-60 h-14">
            <Link to="/classes">
              <div className="pl-4 ml-8 -mt-4 pt-4 w-54 h-14">
                <img
                  className="transform rotate-180 inline-block mr-2 mb-1"
                  src="/assets/icon-arrow.png"
                  alt=""
                />
                クラスの一覧へ戻る
              </div>
            </Link>
          </div>
          <h2 className="text-2xl font-bold text-center mb-3">
            {`${state.className} 長文 リスニング状況`}
          </h2>
          <div className="flex justify-center items-center mb-4">
            <Link
              to={`/classes/${params.class_id}/long_sentence/categories`}
              state={{ className: state.className }}
              className="button flex justify-center items-center px-3 py-1"
            >
              <img
                className="transform rotate-90 mr-2"
                src="/assets/icon-arrow_up.svg"
                alt=""
              />
              カテゴリ別 リスニング状況へ
            </Link>
          </div>
          <ListeningResultList
            studentListeningAchievements={studentListeningAchievements}
          />
        </div>
      </div>
    </div>
  );
};
